import { mediaUrl } from '../config'
import { triggerBlobDownload } from './backendArtifacts'

const DEFAULT_PAYMENT_EXPORT_FILENAME = 'erp_to_kl.txt'

export function resolvePaymentExportUrl(url) {
  const rawUrl = String(url || '').trim()
  if (!rawUrl) {
    return ''
  }
  if (/^(https?:|blob:|data:)/i.test(rawUrl)) {
    return rawUrl
  }
  if (rawUrl.startsWith('//')) {
    return `${window.location.protocol}${rawUrl}`
  }
  const mediaPath = rawUrl.replace(/^\/media\/?/, '/')
  return `${mediaUrl}${mediaPath.startsWith('/') ? mediaPath : `/${mediaPath}`}`
}

export function paymentExportFilename(response) {
  return response.filename || (response.data && response.data.filename) || DEFAULT_PAYMENT_EXPORT_FILENAME
}

export function paymentExportErrorMessage(response) {
  const messages = {
    access_denied: 'Недостаточно прав для выгрузки платежных поручений',
    validation_error: 'Некорректный запрос на выгрузку платежных поручений',
    not_found: 'Платежное поручение не найдено',
    mixed_banks: 'Выбранные платежные поручения относятся к разным банкам плательщика',
    missing_required_fields: 'Не хватает обязательных полей платежного поручения',
    internal: 'Не удалось выгрузить платежные поручения'
  }
  const details = response.details || {}
  const fields = Array.isArray(details.fields) && details.fields.length
    ? `: ${details.fields.join(', ')}`
    : ''
  return `${messages[response.error] || response.message || messages.internal}${fields}`
}

export function downloadPaymentExport(response) {
  const url = resolvePaymentExportUrl(response.url || (response.data && response.data.url))
  if (!url) {
    return Promise.reject(new Error('missing_export_url'))
  }
  return fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error('download_failed')
      }
      return res.blob()
    })
    .then((file) => {
      triggerBlobDownload(file, paymentExportFilename(response))
    })
}
